// @flow

import styled, { css } from 'styled-components';
import media from '../../../../../../helpers/media';
import type { Theme } from '../../../../../../types';

export default styled<any, Theme>('section')`
  width: 100%;

  ${media.md(css`
    width: 50%;
  `)}

  &:nth-of-type(1) {
    & > section:nth-child(even) {
      ${media.md(css`
        display: none;
      `)}
    }
  }

  &:nth-of-type(2) {
    display: none;
    ${media.md(css`
        display: block;
      `)}
    & > section:nth-child(odd) {
      display: none;
    }
  }
`;
